// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1PbpW","content":"LayoutSettings_content__SeKQj"};